import { getProfile, saveProfile, deleteProfile, getProfileById, savePermissions, getPermissions, getAllPermissionsByProfile } from '../../../shared/data-services/management-profile-service';
import { updateAirportsByEmployee, getEmployeesWithAirports, getAllAirportsByEmployee, GetAllEmployeesWithAirportsByAirport, deleteAirportsByEmployee, GetAllEmployeesByAirport } from '../../../shared/data-services/management-airport-service';
import { bulkUpdateAirportsByEmployees } from '../../../shared/data-services/management-employee-service';
import { getAirports } from '../../../shared/data-services/airport-service';
import { getEmployeesByAirport, getAllEmployeesByAirport, getUserFaceFeature, saveNewUser, updateUser } from '../../../shared/data-services/talmaid-service';

export async function getAllProfile (){
  const data = await getProfile();
  return data || [ ];
};

export async function getemployeesByAirport(AirportId, companyId){
  const data = await getEmployeesByAirport(AirportId, companyId);
  return data;
}

export async function getallemployeesWithAirports(AirportId, companyId){
  const data = await GetAllEmployeesWithAirportsByAirport(AirportId, companyId);
  return data;
}

export async function getallemployeesByAirportForEdit(AirportId, companyId){
    const data = await GetAllEmployeesByAirport(AirportId, companyId);
    return data;
  }

export async function getAllAirports (companyId){
  const data = await getAirports(companyId);
  return data;
};

// export async function getEmployees (){
//   const data = await getEmployeesWithProfiles();
//   return data || [ ];
// };

export async function getEmployees (companyId){
    const data = await getEmployeesWithAirports(companyId);
    return data || [ ];
  };

// export async function updateAllProfilesByEmployee (profiles){
//   await updateProfilesByEmployee(profiles);
//   return;
// };

export async function updateAllAirportsByEmployee (airports, employee){
    await updateAirportsByEmployee(airports, employee);
    return;
};

// export async function getProfilesByEmployee (employeeId){
//   const data = await getAllProfilesByEmployee(employeeId);
//   return data || [ ];
// };

export async function getAirportsByEmployee (employeeId){
    const data = await getAllAirportsByEmployee(employeeId);
    return data || [ ];
  };

export async function getSelectedProfile (id){
  const data = await getProfileById(id);
  return data;
};

export async function saveSelectedProfile (id, description){
  const Profile = {
    id, 
    description
  }

  const data = await saveProfile(Profile);
  return data;
};


export async function getPermissionByProfile (profileId){
  const data = await getAllPermissionsByProfile(profileId);
  return data || [ ];
};

export async function getAllPermissions(){
  const data = await getPermissions();
  return data || [];
};


export async function saveSelectedPermissions (permissions, profileId, profileName, action){
  // const Permission = {
  //   code, 
  //   description: description
  // }
  if(action === 'CREAR'){
    profileId = null
  }
  const data = await savePermissions(permissions, profileId, profileName);
  return data;
};

export async function deleteAirports (id, employee){
  const data = await deleteAirportsByEmployee(id, employee);
  return data;
};

export async function bulkAssignAirports (employeeIds, airports, employee){
  const data = await bulkUpdateAirportsByEmployees(employeeIds, airports, employee);
  return data;
};

export async function getallemployeesByAirport(AirportId, companyId){
  const data = await GetAllEmployeesWithAirportsByAirport(AirportId, companyId);
  return data;
};